import { NavLink } from "react-router-dom";
import logo from "../../assets/ZS_NEXATECH_LOGO_NEW_optimized.png";
import { CONTACT_INFO, SOCIAL_LINKS, WEBSITE_URL } from "../../config/constants";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-shell">
        <div className="py-8 grid gap-8 md:grid-cols-3 items-start">
          {/* Company Info */}
          <div className="transform transition-all duration-500 hover:scale-105 hover:-translate-y-2" style={{ perspective: '1000px' }}>
            <div className="flex items-center gap-3 mb-3">
              <img
                src={logo}
                alt="ZS NEXATECH Logo"
                className="footer-logo holo-logo h-32 w-auto transition-all duration-500 hover:scale-125 hover:drop-shadow-2xl self-center"
                loading="lazy"
                style={{
                  transformStyle: 'preserve-3d',
                  animation: 'none'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'scale(1.25) rotateY(10deg) rotateX(-5deg)';
                  e.target.style.filter = 'drop-shadow(0 20px 40px rgba(59, 130, 246, 0.5))';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'scale(1) rotateY(0deg) rotateX(0deg)';
                  e.target.style.filter = 'drop-shadow(0 0px 0px rgba(59, 130, 246, 0))';
                }}
              />
              <h3 className="text-xl font-black text-white tracking-wide leading-tight" style={{ 
                textShadow: '2px 2px 6px rgba(245, 158, 11, 0.45)',
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }}>
                <span className="holo-text">
                  ZS NEXATECH
                </span>
              </h3>
            </div>
            <p className="text-sm text-white/80 leading-relaxed font-medium transition-all duration-300 hover:text-white">
              Elite Product Engineering. From concept to deployment, we build secure, scalable, and conversion-focused digital platforms.
            </p>
            <p className="text-xs text-amber-200/90 mt-2 font-semibold">
              {WEBSITE_URL.replace("https://", "")}
            </p>
          </div>

          {/* Quick Links */}
          <div className="transform transition-all duration-500 hover:scale-105 hover:-translate-y-2" style={{ perspective: '1000px' }}>
            <h3 className="text-xl font-black text-white mb-3 tracking-wide" style={{ 
              textShadow: '2px 2px 6px rgba(245, 158, 11, 0.45)',
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }}>
              <span className="holo-text">
                Company
              </span>
            </h3>
            <nav className="flex flex-col gap-2 text-sm font-semibold">
              <NavLink to="/about" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ About
              </NavLink>
              <NavLink to="/services" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ Services
              </NavLink>
              <NavLink to="/contact" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ Contact
              </NavLink>
              <NavLink to="/blog" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ Blog
              </NavLink>
              <a href={SOCIAL_LINKS.linkedin} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ LinkedIn
              </a>
            </nav>

            <h4 className="text-sm font-black text-white mt-5 mb-2 tracking-wide">Services</h4>
            <nav className="flex flex-col gap-2 text-sm font-semibold">
              <NavLink to="/services" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ Product Development
              </NavLink>
              <NavLink to="/services" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ Cloud Architecture
              </NavLink>
              <NavLink to="/services" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ AI Solutions
              </NavLink>
            </nav>

            <h4 className="text-sm font-black text-white mt-5 mb-2 tracking-wide">Explore</h4>
            <nav className="flex flex-col gap-2 text-sm font-semibold">
              <NavLink to="/" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ Home
              </NavLink>
              <NavLink to="/portfolio" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ Portfolio
              </NavLink>
              <NavLink to="/founder" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ Founder
              </NavLink>
              <NavLink to="/student-projects" className="text-white/80 hover:text-amber-200 transition-all duration-300 hover:translate-x-2 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}>
                ✦ Student Projects
              </NavLink>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="transform transition-all duration-500 hover:scale-105 hover:-translate-y-2" style={{ perspective: '1000px' }}>
            <h3 className="text-xl font-black text-white mb-3 tracking-wide" style={{ 
              textShadow: '2px 2px 6px rgba(245, 158, 11, 0.45)',
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }}>
              <span className="holo-text">
                Get in Touch
              </span>
            </h3>
            <div className="space-y-3 text-sm">
              <div className="transform transition-all duration-300 hover:translate-x-2">
                <p className="font-bold text-white mb-1">📧 Email:</p>
                <a href={`mailto:${CONTACT_INFO.email}`} className="text-white/80 hover:text-amber-200 font-semibold transition-all duration-300 hover:scale-105 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                  {CONTACT_INFO.email}
                </a>
              </div>
              <div className="transform transition-all duration-300 hover:translate-x-2">
                <p className="font-bold text-white mb-1">💬 WhatsApp:</p>
                <a href={CONTACT_INFO.whatsappUrl} target="_blank" rel="noreferrer" className="text-white/80 hover:text-amber-200 font-semibold transition-all duration-300 hover:scale-105 inline-block whatsapp-link" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
                  {CONTACT_INFO.phone}
                </a>
              </div>
              <div className="transform transition-all duration-300 hover:translate-x-2">
                <p className="font-bold text-white mb-1">📍 Location:</p>
                <p className="text-white/80 font-semibold mb-1">
                  Ahmedabad, Gujarat, India
                </p>
                <a 
                  href="https://www.google.com/maps/place/Ahmedabad,+Gujarat,+India" 
                  target="_blank" 
                  rel="noreferrer" 
                  className="text-amber-300 hover:text-amber-200 font-semibold transition-all duration-300 hover:scale-105 inline-flex items-center gap-1" 
                  style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)', pointerEvents: 'auto', touchAction: 'manipulation' }}
                >
                  View on Map →
                </a>
              </div>
              <div className="transform transition-all duration-300 hover:translate-x-2">
                <p className="font-bold text-white mb-3 mt-4">🌐 Connect with us:</p>
                <div className="flex gap-3">
                  <a 
                    href={SOCIAL_LINKS.linkedin} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-icon-link"
                    aria-label="LinkedIn"
                  >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                  <a 
                    href={SOCIAL_LINKS.twitter} 
                    target="_blank" 
                    rel="noreferrer"
                    className="social-icon-link"
                    aria-label="Twitter"
                  >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                  </a>
                  <a 
                    href={SOCIAL_LINKS.facebook} 
                    target="_blank" 
                    rel="noreferrer"
                    className="social-icon-link"
                    aria-label="Facebook"
                  >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd"/>
                    </svg>
                  </a>
                  <a 
                    href={SOCIAL_LINKS.instagram} 
                    target="_blank" 
                    rel="noreferrer"
                    className="social-icon-link"
                    aria-label="Instagram"
                  >
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 py-5">
          <div className="grid gap-4 md:grid-cols-2 mb-4">
            <div className="text-center md:text-left">
              <p className="text-sm text-white/80 mb-2">
                <a href="/privacy-policy" className="text-amber-400 hover:text-amber-300 transition">Privacy Policy</a>
                {" "} • {" "}
                <a href="/cookie-policy" className="text-amber-400 hover:text-amber-300 transition">Cookie Policy</a>
                {" "} • {" "}
                <a href="/terms-conditions" className="text-amber-400 hover:text-amber-300 transition">Terms & Conditions</a>
              </p>
            </div>
          </div>
          <div className="text-center">
            <p className="text-sm font-bold text-white/90 mb-1 transition-all duration-300 hover:scale-105 inline-block">
              © {new Date().getFullYear()} <span className="font-black holo-text" style={{ textShadow: '2px 2px 6px rgba(56, 189, 248, 0.35)' }}>ZS NEXATECH</span>. All rights reserved.
            </p>
            <p className="text-xs font-semibold text-white/70 italic transform transition-all duration-500 hover:text-amber-200 hover:scale-110 inline-block" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
              ✨ Crafted with precision and passion ✨
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
